import { Form } from 'react-bootstrap';
import './CheckMember.css'; // Custom CSS

const CheckMember = ({
  handleCheck,
}: {
  handleCheck: (value: 'yes' | 'no') => void;
}) => {
  // null, true, false

  const handleRadioChange = (e: any) => {
    handleCheck(e.target.value);
  };

  return (
    <div className='d-flex gap-3'>
      <span className='text-center mb-4'>Have you previously registered?</span>

      <Form.Group className='mb-3 d-flex gap-2'>
        <Form.Check
          type='radio'
          label='Yes'
          name='isRegistered'
          value='yes'
          onChange={handleRadioChange}
        />
        <Form.Check
          type='radio'
          label='No'
          name='isRegistered'
          value='no'
          onChange={handleRadioChange}
        />
      </Form.Group>
    </div>
  );
};

export default CheckMember;
